import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/liikunta';
const recap = ['6 tomów', '5 bonusów', '240 stron', 'Kl. 1–8'];
const reassurances = ['Natychmiastowy dostęp', 'PDF gotowe do druku', '7 dni gwarancji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15ckg2l9o5u77">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jbtx1n5p8sc8" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1ebxt1nx050wo">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t1wsdu0amidq">
          Twoje lekcje przyrody mogą być <em className="text-red-700" data-id="element-116" data-mp="1o5y4s8msh4ed">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="2245ym7oj3plb">
          Zamiast szukać kart pracy po nocach, samemu wymyślać doświadczenia i spędzać niedziele
          nad konspektami, masz jeden uporządkowany pakiet na cały rok szkolny. Więcej czasu na to,
          co naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="s6il3at4bam2">
          Twoi uczniowie. Twoje lekcje. Twoje życie po szkole.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="124g8jw35l3dm">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="162m7wj1nwgoi">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-121" data-mp="1b28p13km2h2l">Wcześniej <s data-id="element-122" data-mp="1fu9uo6n9x9jn">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fvb8ujzl6c5l">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1ks1pp9j7tbs2">Płatność jednorazowa – bez subskrypcji.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ptqysjmvnfdi">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1tu18o7dsipxn" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1tuavxn7gaizn">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lvkqcajnx81p">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3lxfahmn40w4q" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}